import { decamelizeKeys } from 'humps';
import get from 'lodash/get';

import resolve from '../../../../api-client';
import { selectSurveyClient, selectParticipant } from '../selectors';
import {
  RESULT__INIT,
  RESULT__FETCH,
  RESULT__FINALISE,
  RESULT__REDIRECTING,
  RESULT__SET_CURRENT_PAGE_ID,
} from '../constants';
import {
  getResultInitUrl,
  getResultItemUrl,
  getResultFinishUrl,
  getResultRedirectedUrl,
} from '../../util';

const fetch = (surveyId, token, version) =>
  resolve({
    url: getResultItemUrl(surveyId),
    method: 'get',
    type: RESULT__FETCH,
    params: {
      token,
      version,
    },
    retry: 3,
  });

const create = ({ isTestMode, surveyId, version, participantId, resultParams, recaptchaToken }) =>
  resolve({
    url: getResultInitUrl(),
    method: 'post',
    type: RESULT__INIT,
    data: decamelizeKeys({
      isTestMode,
      participantId,
      recaptchaToken,
      surveyId,
      version,
      ...resultParams,
    }),
  });

export const setCurrentPageId = (currentPageId) => {
  return {
    type: RESULT__SET_CURRENT_PAGE_ID,
    data: {
      currentPageId,
    },
  };
};

export const resultInit =
  ({ surveyId, isTestMode, recaptchaToken }) =>
  (dispatch, getState) => {
    const state = getState();
    const participant = selectParticipant(state);
    const surveyClient = selectSurveyClient(state);
    const { initInFlight, token, version } = surveyClient;
    if (initInFlight) return Promise.resolve(null);
    return dispatch(
      token
        ? fetch(surveyId, token, version)
        : create({
            isTestMode,
            participantId: get(participant, 'id'),
            recaptchaToken,
            resultParams: get(window, 'beagly.resultParams'),
            surveyId,
            version,
          }),
    );
  };

export const resultInitPreview = (surveyId) => create({ surveyId });

export const surveyClientFinalise = (token, invitationToken) => (dispatch) =>
  dispatch(
    resolve({
      url: getResultFinishUrl(),
      method: 'put',
      type: RESULT__FINALISE,
      data: decamelizeKeys({
        token,
        invitationToken,
      }),
      retry: 3,
    }),
  );

export const surveyClientRedirect = (token, invitationToken, redirectLink) => (dispatch) =>
  dispatch(
    resolve({
      url: getResultRedirectedUrl(),
      method: 'put',
      type: RESULT__REDIRECTING,
      data: decamelizeKeys({
        token,
        invitationToken,
        redirectLink,
      }),
      retry: 3,
    }),
  );
